
(function ($) {
  'use strict';

  var modal = null;
  var itemEl = null;

  function init() {
    modal = document.getElementById('CartAddedModal');
    itemEl = document.getElementById('CartAddedModalItem');
    if (!modal) return;

    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-modal-close')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function openModal(item) {
    if (!modal) return;
    renderItem(item);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-added-modal-open');
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-added-modal-open');
  }

  function renderItem(item) {
    if (!itemEl || !item) return;
    var image = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_100x$1$2') : '';
    itemEl.innerHTML =
      (image ? '<img src="' + image + '" alt="">' : '') +
      '<div class="cart-added-modal__item-details">' +
      '<strong>' + escapeHtml(item.product_title || '') + '</strong>' +
      (item.variant_title ? escapeHtml(item.variant_title) + '<br>' : '') +
      'Qty: ' + (item.quantity || 1) +
      '</div>';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // This is the key part: jQuery fires "ajaxSuccess" on document for every
  // successful $.ajax() call on the page (unless a request explicitly opts
  // out with `global: false`, which Venture's add-to-cart call does not).
  // We just watch for the one hitting /cart/add.js and react to it.
  $(document).ajaxSuccess(function (event, xhr, settings) {
    if (!settings || !settings.url || settings.url.indexOf('/cart/add.js') === -1) {
      return;
    }
    var item;
    try {
      item = JSON.parse(xhr.responseText);
    } catch (e) {
      return;
    }
    // /cart/add.js returns the line item's NEW TOTAL quantity in the cart
    // (e.g. adding qty 1 to an existing qty 1 line returns quantity: 2), not
    // how many were added just now. Read the actual submitted quantity from
    // the request itself so the modal reflects "what you just added."
    if (settings.data) {
      var submittedQty = new URLSearchParams(settings.data).get('quantity');
      if (submittedQty) {
        item.quantity = parseInt(submittedQty, 10) || item.quantity;
      } else {
        item.quantity = 1; // no quantity field on the form means 1 was added
      }
    }
    openModal(item);
  });
})(jQuery);